import { render, staticRenderFns } from "./GuppySvgIcons.vue?vue&type=template&id=4ed3535a&"
import script from "./GuppySvgIcons.vue?vue&type=script&lang=js&"
export * from "./GuppySvgIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports